// extracted by mini-css-extract-plugin
export var centerText = "_fl-8";
export var container = "_fl-0";
export var doughnutContainer = "_fl-7";
export var legend = "_fl-a";
export var legendItemColorDisplay = "_fl-b";
export var legendItemLabel = "_fl-d";
export var legendItemValue = "_fl-c";
export var lg = "_fl-5";
export var maxWidth = "_fl-9";
export var md = "_fl-4";
export var responsive = "_fl-6";
export var sm = "_fl-3";
export var xs = "_fl-2";
export var xxs = "_fl-1";